module.exports = __webpack_public_path__ + "static/P2LPC.053820ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/P2LPC.png
// module id = 57
// module chunks = 21434532657768 117696030705815 145011745361637